import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from "@angular/forms";
import { Savings } from "../../savings/shared/savings.model";
import { SavingsService } from "../../savings/shared/savings.service";
import { SavingscustomdefaultcaseService } from "./shared/savingscustomdefaultcase.service";

import { ToasterserviceService } from "../../utility/shared/toasterservice.service";
import { Toastpayload } from "../../utility/shared/toastpayload";
import { IndividualConfig, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-savingscustomdefaultcase',
  templateUrl: './savingscustomdefaultcase.component.html',
  styleUrls: ['./savingscustomdefaultcase.component.css']
})
export class SavingscustomdefaultcaseComponent implements OnInit {

  AddButtonText: string;
  ErrorText: string;
  SavingsId: number;
  Id: number;
  readonlyTextBox: boolean = false;
  savings = new Savings();

  DepositType : string;
  LoanPurpose : string;
  Address : string;
  Name : string;
  toast: Toastpayload;

  constructor(public savingsCustomDefaultCaseService: SavingscustomdefaultcaseService,
    private savingsService: SavingsService,
    private toasterserviceService: ToasterserviceService,
    private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.Id = +  params['Id'];
      this.SavingsId = +  params['SavingsId'];
    });

    this.resetForm();
    this.readonlyTextBox =true;

    if (Number.isNaN(this.Id)) {
      this.savingsCustomDefaultCaseService.selectedSavingsCustomDefaultCase.Id = 0;
      this.savingsCustomDefaultCaseService.selectedSavingsCustomDefaultCase.Flag = 1;
      this.savingsCustomDefaultCaseService.selectedSavingsCustomDefaultCase.IsActive = true;
      this.AddButtonText = "Save";
    }
    else {
      this.savingsCustomDefaultCaseService.selectedSavingsCustomDefaultCase.Id = +this.Id;
      this.savingsCustomDefaultCaseService.selectedSavingsCustomDefaultCase.SavingsId = +this.SavingsId;
      this.savingsCustomDefaultCaseService.selectedSavingsCustomDefaultCase.Flag = 2;
      this.savingsCustomDefaultCaseService.selectedSavingsCustomDefaultCase.IsActive = true;
      this.AddButtonText = "Edit & Save";
      this.GetSavingsDetails(+this.SavingsId)
      // this.GetInstallmentChangeById();
    }
  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();
                                                                 
    this.savingsCustomDefaultCaseService.selectedSavingsCustomDefaultCase = {
      Id: 0,
      SavingsId: null,
      InstallmentNo: 0,
      EmployeeId: null,
      EmployeeBranchId: null,
      CompanyId: null,
      SaasId: null,
      IsActive: null,
      Remarks:null,
      Flag: 0
    }
  }

  GetSavingsDetails(SavingsId: any) {

    this.savings = new Savings();
    this.savings.Id = SavingsId;
    this.savings.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.savingsService.FetchSavingsById(this.savings)
      .toPromise()
      .then(data => {    
        console.log(data);
        this.Address = data.Address;
        this.Name = data.CustomerName;
        this.savingsCustomDefaultCaseService.selectedSavingsCustomDefaultCase.InstallmentNo = data.TotalInstallmentCount;
      })
      .catch(err => { console.log(err) });
  }

  public ClickSearch(event: any) {

    if (this.savingsCustomDefaultCaseService.selectedSavingsCustomDefaultCase.SavingsId != null) {
      this.GetSavingsDetails(this.savingsCustomDefaultCaseService.selectedSavingsCustomDefaultCase.SavingsId)
    }
  }

  // GetInstallmentChangeById(){
  //   this.savingsCustomDefaultCaseService.FetchInstallmentChangeById(this.savingsCustomDefaultCaseService.selectedSavingsCustomDefaultCase)
  //   .toPromise()
  //   .then(data => {
  //     this.savingsCustomDefaultCaseService.selectedSavingsCustomDefaultCase.Id = data.Id ;
  //     this.savingsCustomDefaultCaseService.selectedSavingsCustomDefaultCase.SavingsId = data.SavingsId ;
  //     this.savingsCustomDefaultCaseService.selectedSavingsCustomDefaultCase.InstallmentNo = data.InstallmentOption;
  //   })
  // }

  onSubmit(form: NgForm) {

    if (this.savingsCustomDefaultCaseService.selectedSavingsCustomDefaultCase.SavingsId != null) {
      form.value.InstallmentNo = this.savingsCustomDefaultCaseService.selectedSavingsCustomDefaultCase.InstallmentNo;
      this.savingsCustomDefaultCaseService.IUDDefaultCase(form.value)
        .toPromise()
        .then(data => {

          this.toast = {
            message: "The Default Savings No. have been deleted",
            title: 'Default Savings No deletion',
            ic: {
              timeOut: 3000,
              closeButton: true,
            } as IndividualConfig,
            type: 'success',
          };

          this.toast.message = 'Default installment number saved.!'
          this.toast.type = 'success';
          this.toasterserviceService.showToast(this.toast);

          this.router.navigate(['/savingscustomdefaultcaselist']);
        })
    }
  }

}
